addEventListener("DOMContentLoaded", () => {
  const elm = document.querySelector(".skip-link");
  if (elm) elm.style.transition = "transform 150ms ease-in";
});
